import React from 'react'
import {connect} from 'react-redux'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {makeStyles} from "@material-ui/core";
import DoubleButton from "components/popup/components/DoubleButton";
import DescriptionIcon from '@material-ui/icons/Description';
import TypographyWithIcon from "components/TypographyWithIcon";
import VS from "constants/ValidationShema";
import PropTypes from 'prop-types'
import Select from "components/Select";
import {ContractorDocumentType, ContractorDocumentTypeSelectItems} from "constants/ContractorDocumentType";
import {TrueFalseWithEmpty} from "constants/TrueFalseItems"

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    disabledEmpty: {
        fontStyle: 'italic'
    },
    textField: {
        wordBreak: "break-word",
        whiteSpace: 'pre-line',
        marginBottom: theme.spacing(2)
    }
}));


function EditFilePopup(
    {
        file,
        onCancel,
        onUpdate,
        formSubmit,
    }) {

    const classes = useStyle();
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    return (
        <Dialog
            title={Tr('edit_type')}
            open={true}
            maxWidth={'sm'}
            dialogActions={
                <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={Tr('confirm')}
                    onClickFirst={onCancel}
                    onClickSecond={handleSubmit}
                />}
        >

            <Form
                initialValues={{
                    documentType: file.documentType,
                    containsRodo: file.containsRodo
                }}
                validationSchema={Yup.object().shape({
                    documentType: VS.stringNotOneOf([ContractorDocumentType.RODO], Tr('required_field')),
                    containsRodo: VS.any()
                })}
                onSubmit={onUpdate}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>

                        <TypographyWithIcon Icon={DescriptionIcon} className={classes.margin}>
                            {file.file.name}
                        </TypographyWithIcon>

                        <Select
                            id="containsRodo"
                            formikProps={formikProps}
                            items={TrueFalseWithEmpty}
                            label={Tr('contains_rodo')}
                            className={classes.select}
                        />

                        <Select
                            id="documentType"
                            formikProps={formikProps}
                            items={ContractorDocumentTypeSelectItems()}
                            label={Tr('document_type')}
                            className={classes.select}
                        />
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

EditFilePopup.propTypes = {
    file: PropTypes.shape({
        file: PropTypes.shape({
            name: PropTypes.string.isRequired
        }).isRequired,
        identity: PropTypes.number.isRequired,
        documentType: PropTypes.string.isRequired,
    }).isRequired,
    onCancel: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(EditFilePopup);